import instanceService from './instance'

import { SEARCH_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(SEARCH_SERVER_URL)

export const searchService = {
  searchJewels,
  searchClients,
  searchGlobal,
  searchDeals,
  getClientFacets,
  getDealsFacets,
  searchCriminal,
  getAddresses,
  getGovernmentAgency,
}

function searchJewels(name, size = 20) {
  const data = {
    size,
    from: 0,
    term: name
  }
  const options = {
    method: 'POST',
    data: data,
    url: `/jewel/search`
  }
  return instance(options)
}

function searchClients(data) {
  const options = {
    method: 'POST',
    url: '/client/search',
    data
  }
  return instance(options)
}

function searchGlobal(data) {
  const options = {
    method: 'POST',
    url: '/global/search',
    data
  }
  return instance(options)
}
function searchDeals(data) {
  const options = {
    method: 'POST',
    url: '/deal/search',
    data
  }
  return instance(options)
}

function getClientFacets() {
  const options = {
    method: 'POST',
    url: '/client/aggs'
  }
  return instance(options)
}


function getDealsFacets() {
  const options = {
    method: 'POST',
    url: '/deal/aggs'
  }
  return instance(options)
}

function searchCriminal(data) {
  const options = {
    method: 'POST',
    data,
    url: '/criminal/search'
  }

  return instance(options)
}

function getAddresses (data) {
  const options = {
    method: 'POST',
    url: '/address',
    data
  }
  return instance(options)
}

function getGovernmentAgency (data) {
  const options = {
    method: 'POST',
    url: '/authority/search',
    data
  }
  return instance(options)
}